import React from 'react';
import { volumes } from '../data/content';
import { Reveal } from './Reveal';
export function Volumes() {
  return <section className="bg-paper-soft px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="tomos" data-id="element-288" data-mp="1lwbnlo7dmtvf">
      <div className="mx-auto max-w-6xl" data-id="element-289" data-mp="1856iw7p5jbe8">
        <Reveal data-id="element-290" data-mp="1c5gq1nook7uo">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-291" data-mp="1c4yxp2552ds1">
            El sistema completo
          </p>
          <h2 id="tomos" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-292" data-mp="1zwcmwz7ztt8s">
            Los 6 tomos
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-293" data-mp="1qtld13urn5j9">
          {volumes.map((volume, i) => <Reveal key={volume.number} delay={i * 0.04} className="h-full" data-id="element-294" data-mp="1vrmu5j8msus3" data-mpi={i}>
              <article className="flex h-full flex-col rounded-xl border border-paper-line bg-paper p-7" data-id="element-295" data-mp="feetbt2ldkzv">
                <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-grass" data-id="element-296" data-mp="kf2lii2k47vo">
                  Tomo {volume.number}
                </p>
                <h3 className="display mt-3 text-2xl text-ink sm:text-[1.75rem]" data-id="element-297" data-mp="3j9bvemwb0xde">
                  {volume.title}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-298" data-mp="21q7y7c5quwi">
                  {volume.body}
                </p>
                <p className="mt-auto pt-6 text-[13px] font-semibold uppercase tracking-wide text-ink-dim" data-id="element-299" data-mp="3t9cj0l17hzne">
                  {volume.tags}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}